import http from 'plugins/axios'

const BASE = '/ta/admin/tenant/welfare/coupon/statistic'

const request = (kind, action, data, responseType) => http.get({
  url: `${BASE}/${kind}/${action}`,
  data,
  ...(responseType ? { responseType } : {}),
})

export default {
  closePosition(positionId) {
    return http.post({ url: `${BASE}/position/close?positionId=${encodeURIComponent(positionId)}` })
  },
  recycle(kind, data) {
    const query = Object.keys(data).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&')
    return http.post({ url: `${BASE}/${kind}/recycle?${query}` })
  },
  list(kind, data) { return request(kind, 'list', data) },
  summary(kind, data) { return request(kind, 'summary', data) },
  detail(kind, data) { return request(kind, 'detail', data) },
  exportExcel(kind, data) { return request(kind, 'export', data, 'blob') },
}
